/**
 * 获取播报设置 key
 */
export const SETTINGS = ['BORADCAST_SETTINGS'];
